// Search.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function VerseSearch(){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const loading4Home = useSelector((state) => state.home.loading4Home);
  const searchHttpPostData = useSelector((state) => state.verseSearch.searchHttpPostData);
  const pageNumberVerseSearch = useSelector((state) => state.verseSearch.pageNumberVerseSearch);
  const searchResultVerseList = useSelector((state) => state.verseSearch.searchResultVerseList);
  const searchCriteriaListItem = useSelector((state) => state.verseSearch.searchCriteriaListItem);
  const showRemaining = useSelector((state) => state.verseSearch.showRemaining);
  const searchScopeList = useSelector((state) => state.verseSearch.searchScopeList);
  const searchScopeListItemSelected = useSelector((state) => state.verseSearch.searchScopeListItemSelected);
  const searchStringClearButton = useSelector((state) => state.verseSearch.searchStringClearButton);
  const nonSearchStringClearButton = useSelector((state) => state.verseSearch.nonSearchStringClearButton);
  const searchString = useSelector((state) => state.verseSearch.searchString);
  const nonSearchString1 = useSelector((state) => state.verseSearch.nonSearchString1);
  const nonSearchString2 = useSelector((state) => state.verseSearch.nonSearchString2);
  const chipData = useSelector((state) => state.chipArray.chipData);
  const searchStringPlaceHolder = useSelector((state) => state.verseSearch.searchStringPlaceHolder);
  const nonSearchString1PlaceHolder = useSelector((state) => state.verseSearch.nonSearchString1PlaceHolder);
  const nonSearchString2PlaceHolder = useSelector((state) => state.verseSearch.nonSearchString2PlaceHolder);
  const credential = useSelector((state) => state.signIn.credential);
  const circularProgressText = useSelector((state) => state.home.circularProgressText);  
  const userListItem = useSelector((state) => state.home.userListItem);

  const handleOnClickSearch = () => {
    const excludedList = chipData.map(chipDataItem => ({ ...chipDataItem, SearchCriteriaID: searchCriteriaListItem.ID }));
    postPutSearchCriteriaListItem(excludedList, 'VerseSearch');  
    dispatch(setConfirmedSearchString(searchString));
    dispatch(setPageNumberVerseSearch(0));
    let searchCriteria = {
      searchString: searchString,
      excludedList: excludedList
    }
    dispatch(setSearchCriteria(searchCriteria));
    dispatch(setShowfabContentVerseSearch(true));
  }

  const handleOnClickClearSearchString = () => {
    dispatch(setSearchString(''));
    dispatch(setSearchStringClearButton(false));
    dispatch(setShowRemaining(false));
  }

  const handleOnClickClearNonSearchString = () => {
    dispatch(setNonSearchString1(''));
    dispatch(setNonSearchString2(''));
    dispatch(setNonSearchStringClearButton(false));
  }

  const handleOnClickSearchString = () => {
    if (searchString.length > 0) {
      dispatch(setChipData([]));
      getSearchCriteriaListItem('VerseSearch');
      dispatch(setShowRemaining(true));
      dispatch(setSearchScopeListItemSelected(67));
    } 
  }

  const handleOnClickNonSearchString = () => {
    if (nonSearchString1.length > 0 || nonSearchString2.length > 0) {
      const exists = chipData.some(chipDataItem => chipDataItem.Value === nonSearchString1 + searchString + nonSearchString2);
      if (!exists) {
        dispatch(setChipData([...chipData, {Value: nonSearchString1 + searchString + nonSearchString2}]));
      }
      dispatch(setNonSearchString1(''));
      dispatch(setNonSearchString2(''));
    }
  }

  const handleOnChangeSearchString = (e) => {
    let value = e.target.value;
    value = value.replace(/\s+/g, '');
    value.length > 0 ? dispatch(setSearchStringClearButton(true)): dispatch(setSearchStringClearButton(false));
    if (value.length <= MAX_LENGTH_SEARCH_STRING) {
      // dispatch(setSearchStringError(false));
      // dispatch(setSearchStringErrorMessage(''));
      dispatch(setSearchString(value));     
      dispatch(setShowRemaining(false));
    } else {
      // dispatch(setSearchStringError(true));
      // dispatch(setSearchStringErrorMessage('最長 10 個字串'));
    }
  }

  const handleOnChangeNonSearchString2 = (e) => {
    let value = e.target.value;
    value = value.replace(/\s+/g, '');
    if (value.length > 0) {
      dispatch(setNonSearchStringClearButton(true));
    } else {
      if (nonSearchString1.length > 0) {
        dispatch(setNonSearchStringClearButton(true));
      } else {
        dispatch(setNonSearchStringClearButton(false));
      }
    }
    dispatch(setNonSearchString2(value));       
  }

  const handleOnChangeNonSearchString1 = (e) => {
    let value = e.target.value;
    value = value.replace(/\s+/g, '');
    if (value.length > 0) {
      dispatch(setNonSearchStringClearButton(true));
    } else {
      if (nonSearchString2.length > 0) {
        dispatch(setNonSearchStringClearButton(true));
      } else {
        dispatch(setNonSearchStringClearButton(false));
      }
    }
    dispatch(setNonSearchString1(value));  
  }

  const handleOnChange = (e) => {
    let value = e.target.value;
    dispatch(setSearchScopeListItemSelected(value));
  };

  useEffect(() => {
    if (searchHttpPostData !== null) {
      dispatch(setSearchResultVerseList({ResultTotal: -1, VerseList: []}));
      getSearchResultVerseList(searchHttpPostData, 'VerseSearch');
    }
  }, [pageNumberVerseSearch, userListItem?.VerseSearchResultPerPage]);

  useEffect(() => {
    if (searchCriteriaListItem !== null) {
      if (searchCriteriaListItem.SearchCriteriaExcludedList.length > 0) {
        const list = [];
        searchCriteriaListItem.SearchCriteriaExcludedList.map(SearchCriteriaExcludedListItem => (
          list.push({ Value: SearchCriteriaExcludedListItem.Value })
        ));
        let a = chipData;
        if (chipData.length === 0) dispatch(setChipData(list));
      }
    }
  }, [searchCriteriaListItem]);

  useEffect(() => {
    dispatch(setSearchStringPlaceHolder(`輸入最多${MAX_LENGTH_SEARCH_STRING}字`));
    dispatch(setNonSearchString1PlaceHolder(`輸入最多${MAX_LENGTH_NON_SEARCH_STRING1}字`));
    dispatch(setNonSearchString2PlaceHolder(`輸入最多${MAX_LENGTH_NON_SEARCH_STRING2}字`));
  }, []);

  return (

    <div>

      <Card sx={{ boxShadow: 'none', backgroundColor: '#eeeeee', padding: 2 }}>

        <Grid container spacing={2}>

          <Grid size={12}>

            <Typography gutterBottom variant="h5" component="div" sx={{ color: '#bdbdbd' }}>
              包含字串
            </Typography>

            <Paper
              component="form"
              sx={{ boxShadow: 'none', display: 'flex', alignItems: 'center', width: '100%' }}
            >

              <InputBase
                sx={{ ml: 1, flex: 1 }}
                placeholder={searchStringPlaceHolder}
                value={searchString}
                onChange={handleOnChangeSearchString}
              />

              {searchStringClearButton &&
              <IconButton type="button" sx={{ p: '10px', borderRadius: 1 }} onClick={handleOnClickClearSearchString}>
                <ClearIcon  />
              </IconButton>
              }

              <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
              
              <IconButton color="primary" sx={{ p: '10px', borderRadius: 1 }} onClick={handleOnClickSearchString}>
                <CheckIcon  />
              </IconButton>

            </Paper>

          </Grid>   

          {showRemaining &&
          <Grid size={12}>

            <Card sx={{ boxShadow: 'none', backgroundColor: '#bdbdbd', padding: 1 }}>

              <CardMedia>
                <Typography gutterBottom variant="h5" component="div" sx={{ color: 'white' }}>
                  不包含字串
                </Typography>
              </CardMedia>

              <CardContent>

                <Paper
                  component="form"
                  sx={{ boxShadow: 'none', display: 'flex', alignItems: 'center', width: '100%' }}
                >
                  
                  <InputBase
                    sx={{ 
                      ml: 1, 
                      flex: 1, 
                      '& input': {
                        textAlign: 'right', // Right-align the input text
                      },
                    }}
                    placeholder={nonSearchString1PlaceHolder}
                    value={nonSearchString1}
                    onChange={handleOnChangeNonSearchString1}
                  />

                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                  <Typography sx={{ whiteSpace: 'nowrap', flexShrink: 0 }}>
                    {searchString}
                  </Typography>                
                  <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />

                  <InputBase
                    sx={{ ml: 1, flex: 1 }}
                    placeholder={nonSearchString2PlaceHolder}
                    value={nonSearchString2}
                    onChange={handleOnChangeNonSearchString2}
                  />

                </Paper>           

                <Grid container spacing={3}>  

                      <Grid size={12}>

                        <Box
                          display="flex"
                          justifyContent="center" // Horizontally center the buttons
                          sx={{ mt: 1 }}
                        >

                        {nonSearchStringClearButton &&
                        <IconButton 
                          type="button" 
                          sx={{ p: '10px' }} 
                          onClick={handleOnClickClearNonSearchString}
                        >
                          <ClearIcon  />
                        </IconButton>
                        }

                        <IconButton
                          sx={{
                            borderRadius: 1,
                            color: 'primary.main',
                            // bgcolor: 'primary.main',
                            // '&:hover': { bgcolor: 'primary.main' },
                            width: 'auto',
                          }}
                          onClick={handleOnClickNonSearchString}
                        >
                          <CheckIcon />
                        </IconButton> 

                        </Box>

                      </Grid>

                      <Grid size={12}>
                        <ChipArray />
                      </Grid>

                </Grid>

              </CardContent>
        
            </Card>

          </Grid>
          }

          {showRemaining &&
          <Grid size={12}>

            <Select
              size='small'
              value={searchScopeListItemSelected}
              onChange={handleOnChange}
              sx={{
                backgroundColor: 'white',
                display: 'inline-flex',
                height: 35, // typical chip height
                width: '100%'
              }}          
            >
              {/* <MenuItem key={0} value={0}>請選擇範圍</MenuItem> */}
              {searchScopeList.map(searchScopeListItem => (
                <MenuItem key={ searchScopeListItem.ID } value={ searchScopeListItem.ID }>
                  ({ searchScopeListItem.ID }) { searchScopeListItem.Name }
                </MenuItem>
              ))}
            </Select>  

          </Grid>
          }

          {showRemaining &&
          <Grid size={12}>

            <IconButton
              sx={{
                borderRadius: 1,
                bgcolor: 'primary.main',
                '&:hover': { bgcolor: 'primary.main' },
                width: '100%',
              }}
              onClick={handleOnClickSearch}
            >
              <SearchIcon sx={{ color: 'white' }} />
            </IconButton> 

          </Grid>
          }

        </Grid>

      </Card>
      
      {loading4Home && <ClipLoader1 />}
      
      {searchResultVerseList.ResultTotal !== -1 && <SearchResult caller={'VerseSearch'}/>}

      <Grid
          size={12}
          sx={{
              display: 'flex',
              justifyContent: 'center', // horizontally center
              mt: 1, 
              mb: 10
          }}
      >
      </Grid>

    </div>
  )
}